import * as React from 'react';

import {OnboardingBody} from 'shells/onboarding-page/onboarding-body';

export function CustomizeChatbot() {
    return (
        <OnboardingBody
            title='Customize the chatbot for your brand & tone'
            statusText='New: AI Chatbot'
        >
            <p>
                Make the chatbot your own. Adjust its appearance and response style that reflects
                your brand’s voice.
            </p>
        </OnboardingBody>
    );
}
